<div *ngIf="isFoerderbetrag && foerdersummeOffen && foerdersummeOffen > 0" class="d-flex justify-content-end align-items-center mb-2">
    <button (click)="openNewFundsPaymentDialog(null)" class="xfound-button-secondary" translate>payment.neuerMittelabruf</button>
</div>

<kendo-grid *ngIf="payments.length > 0" [kendoGridBinding]="payments">
    <kendo-grid-column [title]="'payment.paymentDate' | translate" [attr.aria-label]="'payment.paymentDate' | translate" field="paymentDate">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <div>{{ dataItem.paymentDate | date: translateService.GetCurrentShortDateFormat() }}</div>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [title]="'payment.amount' | translate" [attr.aria-label]="'payment.amount' | translate" field="amount" format="{0:c}"></kendo-grid-column>
    <kendo-grid-column [title]="'payment.status' | translate" [attr.aria-label]="'payment.status' | translate" field="statusgrund">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <div>{{ statusgrund(dataItem.statusgrund) }}</div>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [title]="'payment.mittelabruf' | translate" [attr.aria-label]="'payment.mittelabruf' | translate" field="mittelabruf">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <div>{{ mittelabruf(dataItem.mittelabruf) }}</div>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [title]="'payment.datumMittelabruf' | translate" [attr.aria-label]="'payment.datumMittelabruf' | translate" field="datumMittelabruf">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <div>{{ dataItem.datumMittelabruf | date: translateService.GetCurrentShortDateFormat() }}</div>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column [title]="'payment.zuwendungsbestaetigung' | translate" [attr.aria-label]="'payment.zuwendungsbestaetigung' | translate" field="zuwendungsbestaetigung">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <div>{{ zwb(dataItem.zuwendungsbestaetigung) }}</div>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column *ngIf="isZahlung" [title]="'payment.actions' | translate" [attr.aria-label]="'payment.actions' | translate">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <button *ngIf="zahlungNichtErfolgt(dataItem.mittelabruf) && mittelAbrufbar(dataItem)" kendoGridEditCommand (click)="openNewFundsPaymentDialog(dataItem)" class="xfound-button-secondary" translate>payment.neuerMittelabruf</button>
        </ng-template>
    </kendo-grid-column>
</kendo-grid>